// Only register the service worker in production when explicitly enabled
let updateSW = () => {}
const ENABLE_PWA = String(import.meta?.env?.VITE_ENABLE_PWA || '').toLowerCase() === 'true'

if (import.meta?.env?.PROD && ENABLE_PWA) {
  (async () => {
    try {
      const spec = 'virtual:pwa-' + 'register'
      const { registerSW } = await import(/* @vite-ignore */ spec)
      updateSW = registerSW({
        onNeedRefresh() {
          if (confirm('A new version of the app is available. Reload to update?')) {
            updateSW(true)
          }
        },
        onOfflineReady() {
          console.log('App is ready to work offline')
        },
        immediate: true,
      })
    } catch (e) {
      console.warn('[PWA] Failed to register service worker module:', e)
    }
  })()
} else {
  // In dev or when disabled, ensure any old service workers are unregistered to prevent stale caches
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister()))
  }
  if ('caches' in window) {
    caches.keys().then(keys => keys.forEach(k => caches.delete(k)))
  }
}

export { updateSW }
